export default __webpack_public_path__ + "static/media/apple.29da7698.png";